import React from "react";
import { Rect } from "./rect";
import { Star } from "./star";
import { Diamond } from "./diamond";
import { EquilateralTriangle } from "./triangle";
import { Circle } from "./circle";

export const PointPicker = ({
  size,
  color,
  borderWidth,
  borderColor,
  datum,
}) => {
  let symbol = 0;
  if (datum && datum.symbol) {
    symbol = datum.symbol;
  }
  return PointPickerFlat({ size, color, borderWidth, borderColor, symbol });
};

export const PointPickerFlat = ({
  size,
  color,
  borderWidth,
  borderColor,
  symbol,
}) => {
  if (symbol % 5 === 4) {
    return (
      <Rect
        {...{
          size,
          color,
          borderWidth,
          borderColor,
        }}
      />
    );
  } else if (symbol % 5 === 3) {
    return (
      <Star
        {...{
          size,
          color,
          borderWidth,
          borderColor,
        }}
      />
    );
  } else if (symbol % 5 === 2) {
    return (
      <EquilateralTriangle
        {...{
          size,
          color,
          borderWidth,
          borderColor,
        }}
      />
    );
  } else if (symbol % 5 === 1) {
    return (
      <Diamond
        {...{
          size,
          color,
          borderWidth,
          borderColor,
        }}
      />
    );
  } else {
    return (
      <Circle
        {...{
          size,
          color,
          borderWidth,
          borderColor,
        }}
      />
    );
  }
};
